/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCcEurocard = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 20H2V4h20zM9.396 13.522l-2.359-2.36-.005.003a2.03 2.03 0 0 0 0 2.87l3.143 3.144a2.03 2.03 0 0 0 2.87 0l.006-.004-2.408-2.407 3.664-3.667a1.76 1.76 0 0 0 0-2.49zm4.07.348a2.045 2.045 0 0 0 0 2.89l3.416-3.414a2.044 2.044 0 0 0 0-2.89zM8.844 9.354c-.77.771-.77 2.02 0 2.79L12.2 8.79c.77-.77.77-2.02 0-2.79z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCcEurocard as CcEurocard };
